module.exports = __webpack_public_path__ + "img/awards.0d7f6618.png";